// Canonical 12-slot palette for the species-diversity layer.
// Kept in sync manually with scripts/generate-species-data.py, which renders
// the on-map dominant-species PNG using the same palette indices. The pie
// chart in the left panel should use SPECIES_PALETTE[rank] for each ranked
// species, so pie slices and map patches share colors.
//
// Slot semantics:
//   0  → transparent (no data / outside polygon)
//   1..10 → the shed's top-10 species (by CSV rank)
//   11 → "Other" (catch-all for species below the 0.5% threshold)
//
// The species-code → slot-index mapping is per-shed and lives in each
// shed's dominant overlay meta.json (`legend` array). This file only owns
// the palette itself.
export const SPECIES_PALETTE: (string | null)[] = [
  null,        // 0 = transparent
  '#1f77b4',   // 1 = rank 1
  '#ff7f0e',   // 2
  '#2ca02c',   // 3
  '#d62728',   // 4
  '#9467bd',   // 5
  '#8c564b',   // 6
  '#e377c2',   // 7
  '#bcbd22',   // 8
  '#17becf',   // 9
  '#7f7f7f',   // 10
  '#cccccc',   // 11 = Other
];

export const SPECIES_OTHER_INDEX = 11;
export const SPECIES_TOP_N = 10;
